import {useStaticQuery, graphql} from 'gatsby';
export const useHeaderData = () => {
	const {sanityHeader} = useStaticQuery(
		graphql`
			query HeaderQuery {
				sanityHeader {
					menu: _rawMenu(resolveReferences: {maxDepth: 9})
					mobileMenu: _rawMobileMenu(resolveReferences: {maxDepth: 9})
					showNoticeBar
					noticeBarCopy: _rawNoticeBarCopy(
						resolveReferences: {maxDepth: 5}
					)
				}
			}
		`,
	);

	return sanityHeader;
};
